import { FC } from "react";
import {
    Dialog,
    DialogActions,
    ThemeProvider,
    Theme,
    StyledEngineProvider,
} from "@mui/material";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import { SugestaoInstalacao } from "../types";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import ReactDOMServer from "react-dom/server";
import moment from "moment";
import { ConteudoModalCorrenteReversa } from "./ConteudoModalCorrenteReversa";
import theme from "src/theme/light";
import "./style.css";

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}


export interface ModalCorrenteReversaProps {
    isOpened: boolean;
    close: () => void;
    onChange: (sugestao_instalacao: SugestaoInstalacao) => void;
}

const ModalCorrenteReversa: FC<ModalCorrenteReversaProps> = ({ isOpened, close, onChange }) => {
    const userInfo = LocalStorage.get("solar.userExtraInfo", true);
    const modalContent = (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <ConteudoModalCorrenteReversa />
            </ThemeProvider>
        </StyledEngineProvider>
    );

    return (
        <>
            <div>
                <Dialog
                    open={isOpened}
                    onClose={close}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth='md'
                >
                
                    { modalContent }

                    <DialogActions>
                        <FlatButton
                            color="secondary"
                            variant="outlined"
                            disableElevation
                            text="Fechar"
                            onClick={close}
                        />                        
                        <FlatButton
                            color="primary"
                            variant="contained"
                            disableElevation
                            text="Estou Ciente"
                            onClick={() => {
                                onChange({
                                    user_id: userInfo?.userId,
                                    user_name: userInfo?.name,
                                    alerta: ReactDOMServer.renderToString(modalContent),
                                    confirmado_em: moment().format("yyyy-MM-DD HH:mm:ss"),
                                })
                            }}
                        />
                    </DialogActions>
                </Dialog>
            </div>
        </>
    );
};

export { ModalCorrenteReversa };
